import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { isNative } from './platform';

export async function hapticSuccess() {
  if (isNative) {
    try {
      await Haptics.impact({ style: ImpactStyle.Medium });
      return;
    } catch {
      /* fall through */
    }
  }
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate([10, 50, 10]);
  }
}

export async function hapticLight() {
  if (isNative) {
    try {
      await Haptics.impact({ style: ImpactStyle.Light });
      return;
    } catch {
      /* fall through */
    }
  }
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate(8);
  }
}
